/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Apr 17 2025
 **/

import { useRef, useEffect, useState } from "react";
import { TransformComponent, TransformWrapper, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

import { Environments, Utility } from "@/frameworks/libraries/utilities";
import VideoPlayerMobile from "./VideoPlayerMobile";
import { TransformComponentMobileStyle, TransformWrapperMobileStyle, VideoControlsWrapper } from "./emotion";
import { MAX_SCALE_MOBILE, MIN_SCALE_MOBILE } from "../constant";

export default function VideoViewerMobile({
	fileID,
	mimeType
}: {
	fileID: string;
	mimeType: string;
	minimize?: boolean;
}) {
	const [videoLoaded, setVideoLoaded] = useState(false);

	const transformWrapperRef = useRef<ReactZoomPanPinchRef | null>(null);
	const videoControlsRef = useRef<HTMLDivElement>(null);

	const partnerURL = Utility.URLNormalize(Environments.env<string>("URL_VIDEO"));

	/* Initialize */
	useEffect(() => {
		if (videoLoaded) {
			const controlbar = document.querySelector(".vjs-control-bar");
			if (controlbar) videoControlsRef.current?.appendChild(controlbar);
		}
	}, [videoLoaded]);

	return (
		<>
			<TransformWrapper
				ref={transformWrapperRef}
				minScale={MIN_SCALE_MOBILE}
				maxScale={MAX_SCALE_MOBILE}
				wheel={{ step: 1 }}
				pinch={{ disabled: false, step: 0.05 }}
				limitToBounds={true}
				centerOnInit={true}
			>
				<TransformComponent
					contentStyle={TransformComponentMobileStyle}
					wrapperStyle={TransformWrapperMobileStyle}
				>
					<div id="transform-content">
						<VideoPlayerMobile
							onLoad={() => setVideoLoaded(true)}
							options={{
								sources: [
									{
										src: `${partnerURL}/filebox/files/${fileID}?playsinline=1`,
										type: mimeType
									}
								],
								autoplay: true
							}}
						/>
					</div>
				</TransformComponent>
			</TransformWrapper>
			<VideoControlsWrapper ref={videoControlsRef} className="video-js vjs-controls-enabled vjs-has-started" />
		</>
	);
}
